import { render, staticRenderFns } from "./LabResultInfoItem.vue?vue&type=template&id=02bf5ee8&"
import script from "./LabResultInfoItem.vue?vue&type=script&lang=js&"
export * from "./LabResultInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports